<template>
  <section id="contact" class="contact-section py-16 py-md-20">
    <div class="contact-bg"></div>
    <v-container class="py-12 position-relative">
      <div class="text-center mb-16" data-aos="fade-up">
        <div class="section-subtitle">YOUR QUESTIONS, ANSWERED</div>
        <span class="subtitle-line"></span>

        <h2 class="section-title">Frequently Asked Questions</h2>
        <span class="subtitle-line"></span>
      </div>
      <v-row class="justify-center">
        <v-col cols="12" md="8">
          <v-expansion-panels
            popout
            class="faq-panels"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <v-expansion-panel
              v-for="(faq, i) in faqs"
              :key="i"
              class="faq-panel-item"
            >
              <v-expansion-panel-header class="faq-header">
                {{ faq.question }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="faq-content">
                <p>{{ faq.answer }}</p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "FaqSection",
  data() {
    return {
      faqs: [
        {
          question: "What services do you offer?",
          answer:
            "We provide a range of home and commercial services, including basic house cleaning, deep cleaning, plumbing service, AC repair & cleaning, house painting, electrician service, and vacant property cleaning.",
        },
        {
          question: "Are your cleaning products safe?",
          answer:
            "Yes, we exclusively use safe, environmentally friendly cleaning supplies that won’t harm your family or pets. Your well-being is our top priority.",
        },
        {
          question: "What is included in a Deep Cleaning?",
          answer:
            "Our deep cleaning is comprehensive. To guarantee that every space is cleaned completely and to our exacting standards, our skilled experts adhere to a detailed, multi-point checklist that covers high-touch areas, internal fixtures, and hidden grime.",
        },
        {
          question: "What areas do you serve?",
          answer:
            "We proudly provide services across various locations in Bangalore, Kochi, and Trivandrum. Please contact us directly for specific area inquiries and service availability near you.",
        },
        {
          question: "How do you ensure quality in your cleaning services?",
          answer:
            "At Oh Yes, we take pride in delivering consistently high standards. Quality isn’t just a promise; it’s built into our process from start to finish through certified teams,standardized checklists, and post-service quality checks, especially for our deep cleaning service.",
        },
      ],
    };
  },
  methods: {
    openContact() {
      this.$emit("open-contact");
    },
  },
};
</script>

<style scoped>
:root {
  --primary-color: #f46523;
  --text-dark: #1a1a1a;
  --text-light: #666;
}

.contact-section {
  position: relative;
  min-height: 80vh;
  background: white;
  overflow: hidden;
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.contact-bg {
  position: absolute;
  inset: 0;
  background: url("https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=80")
    center/cover no-repeat;
  opacity: 0.2;
  background-color: rgba(0, 0, 0, 0.4);
  background-blend-mode: multiply;
}

.position-relative {
  position: relative;
  z-index: 2;
}

.section-subtitle {
  color: black;
  font-weight: 800;
  letter-spacing: 5px;
  font-size: 13px;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.section-title {
  font-size: clamp(2.2rem, 4.5vw, 3.2rem);
  font-weight: 900;
  color: #f46523;
  line-height: 1.1;
  margin-bottom: 8px;
}

.faq-panels {
  box-shadow: none !important;
  border-radius: 12px;
}

.faq-panel-item {
  margin-bottom: 12px;
  border-radius: 12px !important;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
}

:deep(.faq-header) {
  padding: 20px 24px;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-dark);
  transition: color 0.3s ease-in-out;
}

:deep(.v-expansion-panel--active .faq-header) {
  color: var(--primary-color);
  background-color: #fcfcfc;
}

:deep(.v-expansion-panel-header__icon .v-icon) {
  color: var(--primary-color) !important;
  font-size: 24px !important;
  transition:
    transform 0.3s,
    color 0.3s;
}

:deep(.faq-content) {
  padding: 0 24px 20px 24px;
  line-height: 1.7;
  color: var(--text-light);
  font-weight: 500;
}

:deep(.faq-content p) {
  margin-bottom: 0;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.faq-panel-item:hover {
  box-shadow: 0 10px 30px rgba(244, 101, 35, 0.2);
  transform: translateY(-2px);
}
.subtitle-line {
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #f46523, transparent);
  display: inline-block;
  animation: lineGrow 2s infinite ease-in-out;
}
</style>
